import { gql } from '@apollo/client';

const CategoryBannerQuery = gql`
  query CategoryBannerQuery(
    $category: String!
    $language: String!
    $previewToken: String
  ) {
    categoryBanner(
      category: $category
      language: $language
      previewToken: $previewToken
    ) {
      category
      theme
      text_alignment
      body
      background_mobile
      background_desktop
      countdown_date {
        year
        month
        day
        hour
        minute
        second
      }
      countdown_template
    }
  }
`;

export default CategoryBannerQuery;
